var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "add-dialog",
          staticStyle: { "margin-top": "12vh" },
          attrs: {
            visible: _vm.dialogVisible,
            "modal-append-to-body": false,
            width: "500px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v("添加敏感词")
          ]),
          _c(
            "el-form",
            {
              ref: "SensitiveWordForm",
              staticClass: "xForm",
              attrs: {
                "label-position": "left",
                model: _vm.addParams,
                "label-width": "60px",
                center: ""
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "分类", prop: "wordTypeId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.isDisabled,
                        placeholder: "请选择分类"
                      },
                      on: { change: _vm.selectChange },
                      model: {
                        value: _vm.addParams.wordTypeId,
                        callback: function($$v) {
                          _vm.$set(_vm.addParams, "wordTypeId", $$v)
                        },
                        expression: "addParams.wordTypeId"
                      }
                    },
                    _vm._l(_vm.options, function(item) {
                      return _c("el-option", {
                        key: item.wordTypeId,
                        attrs: {
                          label: item.wordTypeName,
                          value: item.wordTypeId
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "敏感词", prop: "wordName" } },
                [
                  _c("el-input", {
                    staticClass: "word-name-input",
                    attrs: {
                      clearable: "",
                      autocomplete: "off",
                      maxlength: "30",
                      "show-word-limit": ""
                    },
                    model: {
                      value: _vm.addParams.wordName,
                      callback: function($$v) {
                        _vm.$set(_vm.addParams, "wordName", $$v)
                      },
                      expression: "addParams.wordName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("div", { staticClass: "word-name-list-wrap" }, [
            _c("div", { staticClass: "title" }, [_vm._v("已有敏感词")]),
            _vm.wordNames.length == 0
              ? _c("div", { staticClass: "tip" }, [_vm._v("请先添加敏感词")])
              : _c(
                  "div",
                  _vm._l(_vm.wordNames, function(item) {
                    return _c(
                      "el-tag",
                      {
                        key: item.ruleId,
                        staticStyle: { margin: "0 4px 8px 0" },
                        attrs: { closable: "", type: "small" },
                        on: {
                          close: function($event) {
                            return _vm.delSelectedHandle(item)
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(item.wordName) + " ")]
                    )
                  }),
                  1
                )
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "20px" },
                  attrs: { size: "small" },
                  on: { click: _vm.cancel }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.confirm }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }